/** @jsxImportSource @emotion/react */
import { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import LordIcon from 'components/global/LordIcon';
import Typography from 'components/global/Typography';
import { MenuItem } from 'components/global/styled/Menu.styled';

import useAccessControl from 'hooks/useAccessControl';
import useChangeTheme from 'hooks/useChangeTheme';

import { THEME } from 'utils/Theme';
import PATHS from 'utils/paths';

import { version as desktopVersion } from '../../../../../../apps/desktop/package.json';
import * as S from './SideBar.styled';
import { profileConfig } from './SideBarConfig';

/**
 * @author @buunsal
 */
const Profile = (props) => {
	const { closePopper } = props;
	const isAuthorized = useAccessControl();
	const darkMode = useSelector((state) => state.layout.darkMode);
	const [versionClick, setVersionClick] = useState(0);

	const handleClickDesktopVersion = () => {
		setVersionClick((prev) => prev + 1);
		if (versionClick === 9) {
			setVersionClick(0);
			window.electronAPI.openDevTools();
		}
	};

	return (
		<S.PopperContainer>
			{profileConfig.map((item, index) => {
				if (
					(item.title === 'darkTheme' && darkMode) ||
					(item.title === 'lightTheme' && !darkMode) ||
					!isAuthorized(item.path)
				) {
					return;
				}
				return (
					<ProfileConfigItem
						key={index}
						item={item}
						index={index}
						darkMode={darkMode}
						closePopper={closePopper}
					/>
				);
			})}
			<Typography
				align="center"
				fullWidth
				color="var(--content-3)"
				variant="caption"
				{...(import.meta.env.VITE_PLATFORM === 'desktop' ? { onClick: handleClickDesktopVersion } : {})}>
				v {import.meta.env.VITE_PLATFORM === 'desktop' ? desktopVersion : import.meta.env.VITE_APP_VERSION}
			</Typography>
		</S.PopperContainer>
	);
};

const ProfileConfigItem = (props) => {
	const { item, index, darkMode, closePopper } = props;

	const { pathname } = useLocation();
	const changeTheme = useChangeTheme();
	const navigate = useNavigate();

	return (
		<MenuItem
			key={index}
			className={pathname.startsWith(PATHS.USER_SETTINGS) && item.title === 'myProfile' ? 'selected' : ''}
			onClick={() => {
				item.action === 'changeTheme' && changeTheme(item.title);
				if (item.path) {
					navigate(item.path);
				}
				if (item.action !== 'changeLanguage') {
					closePopper();
				}
			}}
			style={{
				gap: '0.5rem'
			}}>
			<LordIcon
				primaryColor={darkMode ? THEME.WHITE : THEME.BLACK}
				secondaryColor={darkMode ? THEME.DARK.PRIMARY_COLOR : THEME.LIGHT.PRIMARY_COLOR}
				src={item.lordIcon}
				width={24}
				height={24}
			/>

			<Typography color={pathname === item.path ? 'var(--alwaysWhiteColor)' : 'var(--black)'}>
				{item.title}
			</Typography>
		</MenuItem>
	);
};

export default memo(Profile);
